import azDate from '@azinformatica/loki/src/filters/az-date'

const filter = (dataFim) => {
	return `${azDate(dataFim, 'DD/MM/YYYY')}`
}

export default filter
